export function isOwnerActive(activeOwners, owner) {
    return activeOwners[owner] !== false;
}
/** Distinct owners in the list default to active. */
export function buildActiveOwnersForQueue(queue) {
    const map = {};
    for (const t of queue) {
        if (!(t.owner in map))
            map[t.owner] = true;
    }
    return map;
}
export function mergeActiveOwnersForQueue(queue, existing) {
    const map = { ...existing };
    for (const t of queue) {
        if (!(t.owner in map))
            map[t.owner] = true;
    }
    return map;
}
export function findNextPlayableIndex(queue, fromIndex, activeOwners) {
    for (let i = fromIndex; i < queue.length; i++) {
        const t = queue[i];
        if (t && isOwnerActive(activeOwners, t.owner))
            return i;
    }
    return null;
}
export function findPrevPlayableIndex(queue, fromIndex, activeOwners) {
    for (let i = fromIndex; i >= 0; i--) {
        const t = queue[i];
        if (t && isOwnerActive(activeOwners, t.owner))
            return i;
    }
    return null;
}
export function resolvePlayIndex(queue, index, activeOwners) {
    const t = queue[index];
    if (t && isOwnerActive(activeOwners, t.owner))
        return index;
    return findNextPlayableIndex(queue, index, activeOwners);
}
export function countPlayable(queue, activeOwners) {
    return queue.filter((t) => isOwnerActive(activeOwners, t.owner)).length;
}
export function countSkipped(queue, activeOwners) {
    return queue.length - countPlayable(queue, activeOwners);
}
//# sourceMappingURL=activeOwners.js.map